/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListEvalSuitesRequest = {
  after?: string | undefined;
  limit?: number | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListEvalSuitesRequest$inboundSchema: z.ZodType<
  ListEvalSuitesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEvalSuitesRequest$Outbound = {
  after?: string | undefined;
  limit: number;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEvalSuitesRequest$outboundSchema: z.ZodType<
  ListEvalSuitesRequest$Outbound,
  z.ZodTypeDef,
  ListEvalSuitesRequest
> = z.object({
  after: z.string().optional(),
  limit: z.number().int().default(20),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEvalSuitesRequestToJSON(
  listEvalSuitesRequest: ListEvalSuitesRequest,
): string {
  return JSON.stringify(
    ListEvalSuitesRequest$outboundSchema.parse(listEvalSuitesRequest),
  );
}
export function listEvalSuitesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSuitesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSuitesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSuitesRequest' from JSON`,
  );
}
